import { Fragment } from "react";
import { Container } from "react-bootstrap";
import { Eye, Building, Quote } from "react-bootstrap-icons";
import "./About.css";
import { Reveal } from "../../animate/Reveal";

function About() {
  return (
    <Fragment>
      <section className="aboutHero">
        <div className="aboutHeroInner">
          <div className="aboutBadge">About Us</div>
          <Reveal>
            <h1>
              We are on a mission to revolutionize user messaging experience
              all around the world.
            </h1>
          </Reveal>
          <Reveal>
            <p>
              Our platform is designed to advance social messaging interaction,
              giving users a great experience regardless of location worldwide.
            </p>
          </Reveal>
          <div className="aboutStats">
            <div className="aboutStat">
              <span className="aboutStatValue">5–20</span>
              <span className="aboutStatLabel">Team Members</span>
            </div>
            <div className="aboutStat">
              <span className="aboutStatValue">3+</span>
              <span className="aboutStatLabel">Products</span>
            </div>
            <div className="aboutStat">
              <span className="aboutStatValue">Global</span>
              <span className="aboutStatLabel">User Reach</span>
            </div>
          </div>
        </div>
      </section>

      <section className="aboutSection" id="who-we-are">
        <div className="aboutSectionInner">
          <Reveal>
            <h2 className="aboutSectionTitle">Who We Are</h2>
          </Reveal>
          <Reveal>
            <p>
              SoloChat Messenger is a revolutionary social messaging app that
              enhances users' messaging experience by utilizing advanced
              technologies such as Augmented Reality, Machine Learning, and
              Artificial Intelligence. Our aim is to make getting acquainted
              more enjoyable and effortless while connecting you with your
              neighbors, colleagues, and family. With SoloChat Messenger, you
              can send texts, photos, videos, and even audio messages and make
              video and audio calls with anyone around the world. Our innovative
              messaging feature allows you to share moments with people who
              matter and engage in facetime video sessions with colleagues and
              groups in your circle inside a certified room session. With our
              advanced search system, you can easily find the closest people
              around you and start chatting on SoloChat Messenger. At SoloChat
              Messenger, we believe that communication is the core of our
              services. We understand how sharing activities and experiences
              through video communications, VoIP, instant messaging is
              revolutionizing the world, and we strive to be at the forefront of
              this revolution.
            </p>
          </Reveal>
          <Reveal>
            <p>
              Our initial idea was to create a personal chat meaning just you
              and the person you're chatting with. However, we have expanded our
              services to cater to the needs of our users better.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="aboutStatements">
        <Container>
          <div className="aboutStatementGrid">
            <div className="aboutStatementCard">
              <div className="aboutStatementIcon">
                <Eye />
              </div>
              <Reveal>
                <h3>Our Vision</h3>
                <p>
                  To promote friendship and creativity through social
                  interaction, no matter where they are in the world.
                </p>
              </Reveal>
            </div>
            <div className="aboutStatementCard">
              <div className="aboutStatementIcon">
                <Building />
              </div>
              <Reveal>
                <h3>Our Company</h3>
                <p>
                  SoloChat is a dynamic startup based in Nigeria, specializing
                  in software development and communication services. Our
                  flagship product, SoloChat Messenger, is a social networking
                  and communication app that leverages cutting-edge technology
                  to enhance users' messaging experience. Our headquarters is
                  located in Lagos, Nigeria, and we currently have a startup
                  size of 5–20 employees. We take pride in being a Nigerian
                  company and are committed to contributing to the growth of the
                  technology industry in Nigeria. We believe that with our
                  innovative products and services, we can revolutionize the way
                  people communicate and connect with each other.
                </p>
              </Reveal>
            </div>
          </div>
        </Container>
      </section>

      <section className="aboutFounderSection">
        <Container>
          <Reveal>
            <h2 className="aboutSectionTitle aboutCentered">Meet the Founder</h2>
          </Reveal>
          <div className="aboutFounderLayout">
            <div className="aboutFounderImgWrap">
              <img
                className="grayscale"
                src="solochatFounder.jpeg"
                alt="Favour_Gabriel_Aighangbe_solochatFounder"
              />
            </div>
            <div className="aboutFounderQuote">
              <Quote className="aboutQuoteIcon" />
              <Reveal>
                <h4>
                  We believe that with our innovative products and services, we
                  can revolutionize the way people communicate and connect with
                  each other.
                </h4>
              </Reveal>
              <Reveal>
                <a
                  className="aboutFounderLink"
                  href="https://linkedin.com/in/favour-gabriel"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span>Favour Gabriel Aighangbe</span>
                  <small>Founder &amp; CEO</small>
                </a>
              </Reveal>
            </div>
          </div>
        </Container>
      </section>

      <section className="aboutTeamSection">
        <Container>
          <Reveal>
            <h2 className="aboutSectionTitle aboutCentered">Meet the Team</h2>
          </Reveal>
          <div className="aboutTeamGrid">
            <div className="aboutTeamCard">
              <div className="aboutTeamImage">
                <img
                  className="grayscale"
                  src="solochatCTR.jpeg"
                  alt="Uche Livingstone"
                />
              </div>
              <div className="aboutTeamInfo">
                <h4>Uche Livingstone</h4>
                <p>Co-Founder &amp; Product Manager</p>
              </div>
            </div>
            {/* <div className="aboutTeamCard">
              <div className="aboutTeamImage">
                <img className="grayscale" src="soloChatEngineer.jpeg" alt="Francis Inegbenose" />
              </div>
              <div className="aboutTeamInfo">
                <h4>Francis Inegbenose</h4>
                <p>Frontend Engineer</p>
              </div>
            </div> */}
            {/* <div className="aboutTeamCard">
              <div className="aboutTeamImage">
                <img className="grayscale" src="soloChatJakpa(1).jpg" alt="Jakpa Edison" />
              </div>
              <div className="aboutTeamInfo">
                <h4>Jakpa Edison</h4>
                <p>Product Manager</p>
              </div>
            </div> */}
            {/* <div className="aboutTeamCard">
              <div className="aboutTeamImage">
                <img src="solochatsophiaadepoju.jpg" alt="Sophia Adepoju" />
              </div>
              <div className="aboutTeamInfo">
                <h4>Sophia Adepoju</h4>
                <p>UI/UX</p>
              </div>
            </div> */}
            {/* <div className="aboutTeamCard">
              <div className="aboutTeamImage">
                <img src="solochatsophia.jpg" alt="Sophia Kalagbor" />
              </div>
              <div className="aboutTeamInfo">
                <h4>Sophia Kalagbor</h4>
                <p>Engineer</p>
              </div>
            </div> */}
            {/* <div className="aboutTeamCard">
              <div className="aboutTeamImage">
                <img src="solochataustine.jpg" alt="Austin Ibekwe" />
              </div>
              <div className="aboutTeamInfo">
                <h4>Austin Ibekwe</h4>
                <p>Marketing</p>
              </div>
            </div> */}
          </div>
        </Container>
      </section>

      <section className="aboutProductsSection">
        <Container>
          <Reveal>
            <h2 className="aboutSectionTitle aboutCentered">Other Products</h2>
          </Reveal>
          <div className="aboutProductsGrid">
            <Reveal>
              <a
                className="aboutProductCard"
                href="https://play.google.com/store/apps/details?id=me.solochat.findme"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="aboutProductImage">
                  <img src="findme.webp" alt="FindMe App" />
                </div>
                <div className="aboutProductBody">
                  <h4>FindMe App</h4>
                  <p>
                    A Location based app to find your friends and know their
                    whereabouts
                  </p>
                  <span className="aboutProductLink">View on Play Store</span>
                </div>
              </a>
            </Reveal>
            <Reveal>
              <a
                className="aboutProductCard"
                href="https://play.google.com/store/apps/details?id=me.solochat.formscanx"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="aboutProductImage">
                  <img src="formscanx.png" alt="FormScanX - AI Document Scanner" />
                </div>
                <div className="aboutProductBody">
                  <h4>FormScanX - AI Document Scanner</h4>
                  <p>
                    FormScanX uses artificial intelligence to scan and digitize
                    documents with high accuracy.
                  </p>
                  <span className="aboutProductLink">View on Play Store</span>
                </div>
              </a>
            </Reveal>
          </div>
        </Container>
      </section>
    </Fragment>
  );
}

export default About;
